module.exports = __webpack_public_path__ + "img/search-icon.0e7feb70.svg";